import React, { useEffect, useState } from "react";
import { CircularProgress } from "@material-ui/core";
import { Link } from "react-router-dom";
import "../assets/css/style.css";
import "../style/HomeScreen.css";

const HomeScreenUI = ({ isLoading, news }) => {
  const [links, setlinkJson] = useState();
  useEffect(() => {
    fetch(`${window.location.origin}/app/rbilandinglinks.json`)
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        setlinkJson(data);
      });
  }, []);

  return (
    <main id="main">
      <section id="highlight" className="highlights">
        <div className="container">
          <div className="row content owl-carouse highlights-margin">
            <div className="col-md-6 col-lg-3 pt-4 item">
              <div id="rd" title=" കൂടുതൽ അറിയാൻ ക്ലിക്ക് ചെയ്യുക ">
                {/* <!-- <i className="ri-user-6-line"></i> --> */}
                <i className="ri-user-shared-line"></i>
                <h3> RBI റീട്ടെയിൽ ഡയറക്ട് </h3>
                <p className="font-normal">
                  വ്യക്തിഗത നിക്ഷേപകർക്ക് സർക്കാർ സെക്യൂരിറ്റികളിൽ നിക്ഷേപം
                  സുഗമമാക്കുന്നതിനുള്ള ഒറ്റത്തവണ പരിഹാരമാണ് റീട്ടെയിൽ ഡയറക്ട്
                  സ്കീം.
                </p>
                <span className="txt-more">
                  {" "}
                  കൂടുതൽ <i className="ri-arrow-right-s-line"></i>
                </span>
              </div>
            </div>

            <div className="col-md-6 col-lg-3 pt-4 item hidden">
              <div id="gs" title="കൂടുതൽ അറിയാൻ ക്ലിക്ക് ചെയ്യുക">
                <i className="ri-government-line"></i>
                <h3>സർക്കാർ സെക്യൂരിറ്റികൾ</h3>
                <p className="font-normal">
                  ഒരു സർക്കാർ സെക്യൂരിറ്റി (ജി-സെക്) എന്നത് കേന്ദ്ര സർക്കാരോ
                  സംസ്ഥാന സർക്കാരുകളോ നൽകുന്ന, ക്രയവിക്രയം നടത്താൻ കഴിയുന്ന
                  രേഖയാണ്.
                </p>
                <span className="txt-more">
                  {" "}
                  കൂടുതൽ <i className="ri-arrow-right-s-line"></i>
                </span>
              </div>
            </div>

            <div className="col-md-6 col-lg-3 pt-4 item">
              <div id="pi" title="കൂടുതൽ അറിയാൻ ക്ലിക്ക് ചെയ്യുക">
                <i className="ri-auction-line"></i>
                <h3> പ്രൈമറി ഇഷ്യൂവൻസസ്</h3>
                <p className="font-normal">
                  പ്രൈമറി ഇഷ്യൂവൻസുകൾ എന്നാൽ, കേന്ദ്ര സർക്കാരോ സംസ്ഥാന
                  സർക്കാരുകളോ, സർക്കാർ സെക്യൂരിറ്റികൾ ആദ്യമായി ഇഷ്യൂ ചെയ്യുന്നതോ
                  വീണ്ടും ഇഷ്യൂ ചെയ്യുന്നതോ ആണ്.
                </p>
                <span className="txt-more">
                  {" "}
                  കൂടുതൽ <i className="ri-arrow-right-s-line"></i>
                </span>
              </div>
            </div>

            <div className="col-md-6 col-lg-3 pt-4 item">
              <div id="gb" title="കൂടുതൽ അറിയാൻ ക്ലിക്ക് ചെയ്യുക">
                {/* <!-- <i className="ri-safe-line"></i> --> */}
                <i className="ri-coin-line"></i>
                <h3>സോവറിൻ ഗോൾഡ് ബോണ്ടുകൾ</h3>
                <p className="font-normal">
                  സോവറിൻ ഗോൾഡ് ബോണ്ടുകൾ ഭൗതിക സ്വർണ്ണം കൈവശം വയ്ക്കുന്നതിന് പകരം
                  ഉള്ളതായി കണക്കാക്കപ്പെടുന്നു, അവ, സ്വർണ്ണം ഗ്രാം അളവിൽ
                  രേഖപ്പെടുത്തിയ സർക്കാർ സെക്യൂരിറ്റികളാണ്.
                </p>
                <span className="txt-more">
                  {" "}
                  കൂടുതൽ <i className="ri-arrow-right-s-line"></i>
                </span>
              </div>
            </div>

            <div className="col-md-6 col-lg-3 pt-4 item">
              <div id="sm" title="കൂടുതൽ അറിയാൻ ക്ലിക്ക് ചെയ്യുക">
                <i className="ri-line-chart-line"></i>
                <h3>എൻ.ഡി.എസ്-ഒ.എം. സെക്കൻഡറി മാർക്കറ്റ്</h3>
                <p className="font-normal">
                  എൻ.ഡി.എസ്-ഒ.എം. എന്നത് RBI-യുടെ സ്‌ക്രീൻ അധിഷ്‌ഠിതമായ,
                  സെക്കൻഡറി മാർക്കറ്റിൽ ജി-സെക്-ൽ വ്യാപാരം ചെയ്യുന്നതിനുള്ള
                  അജ്ഞാത ഇലക്ട്രോണിക് ഓർഡർ മാച്ചിംഗ് സിസ്റ്റമാണ്.
                </p>
                <span className="txt-more">
                  {" "}
                  കൂടുതൽ <i className="ri-arrow-right-s-line"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="latest" className="details">
        <div className="container">
          <div className="row content">
            <div className="col-md-12 col-lg-6 pt-4 market">
              <div className="section-title">
                <h2>Market Rates</h2>
              </div>
              <p className="font-normal">
                <a
                  // href="https://www.ccilindia.com/Research/Statistics/Pages/TenorwiseIndicativeYields.aspx"
                  href={links?.tenorHanging}
                  target="_blank"
                  title=" ലിങ്ക് പുതിയ ടാബിൽ തുറക്കും "
                >
                  കാലയളവ് തിരിച്ചുള്ള സൂചിക ആദായം{" "}
                  <i
                    className="ri-external-link-line"
                    style={{ verticalAlign: "-3px" }}
                  ></i>
                </a>
              </p>

              <p className="font-normal" style={{ marginTop: "50px" }}>
                ഏറ്റവും പുതിയ മാർക്കറ്റ് നിരക്കുകൾ പരിശോധിക്കുക <br />
                <a
                  // href="https://www.ccilindia.com/OMHome.aspx"
                  href={links?.rbiNdsOm}
                  target="_blank"
                  title="ലിങ്ക് പുതിയ ടാബിൽ തുറക്കും"
                >
                  എൻ.ഡി.എസ്-ഒ.എം മാർക്കറ്റ് വാച്ച് പേജ്{" "}
                  <i
                    className="ri-external-link-line"
                    style={{ verticalAlign: "-3px" }}
                  ></i>
                </a>
              </p>
            </div>

            <div className="col-md-12 col-lg-6 p-4 news">
              <div className="section-title">
                <h2>Whats's New?</h2>
              </div>
              <div style={{ marginBottom: ".5rem", overflowY: "auto" }}>
                {isLoading ? (
                  <div
                    style={{
                      height: "70px",
                      marginTop: "5%",
                      marginLeft: "50%",
                    }}
                  >
                    <CircularProgress
                      variant="indeterminate"
                      value={100}
                      size={50}
                      color={"inherit"}
                    />
                  </div>
                ) : (
                  <ul style={{ height: "80px" }}>
                    {news &&
                      news.map((element, index) => (
                        <li key={index}>
                          <i className="ri-file-pdf-line"></i>{" "}
                          <a href={element.newsURL} target="_blank">
                            {element.title}
                          </a>
                        </li>
                      ))}
                  </ul>
                )}
                {/* <ul style={{height:'80px'}}>
                    <li>
                      <i className="ri-file-pdf-line"></i>{" "}
                      <a
                        href={PDF1}
                        target="_blank"
                      >
                        ഭാരത സർക്കാർ ഡേറ്റ് ചെയ്ത സെക്യൂരിറ്റികളുടെ ലേലം
                      </a>
                    </li>
                    <li>
                      <i className="ri-file-pdf-line"></i>{" "}
                      <a href={PDF2} target="_blank">
                        91 ദിവസം, 182 ദിവസം, 364 ദിവസം ട്രഷറി ബില്ലുകൾ ലേലം
                      </a>
                    </li>
                    <li>
                      <i className="ri-file-pdf-line"></i>{" "}
                      <a
                        href={PDF3}
                        target="_blank"
                      >
                        സർക്കാർ ഓഹരി - മുഴുവൻ ലേല ഫലങ്ങൾ
                      </a>
                    </li>
                  </ul>*/}
              </div>
              <span className="btn-more" style={{ marginTop: "15px" }}>
                <Link to="/News">
                  {" "}
                  കൂടുതൽ <i className="ri-arrow-right-s-line"></i>
                </Link>
              </span>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};
export default HomeScreenUI;
